import React, { useEffect } from "react";
import {
  Container,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { CustomBootstrapTable } from 'components/Table/CustomBootstrapTable';
import {  CouponsColumn } from "helpers/tableDataMapper";
import { useSelector, useDispatch } from "react-redux";
import { getCoupons } from "store/actions";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { history } from "helpers/utils";

const Coupons = (props) => {
    const dispatch = useDispatch();

    const { couponsList } = useSelector(state => ({
        couponsList: state.coupons.couponsList,
    }));
    
    useEffect(() => {
        let queryPayload = {
            search: '',
        }
        dispatch(getCoupons(queryPayload));
    }, [dispatch, props]);

    const getApplicationDetails = (row) => {
        props.history.push(`/staff/coupons/coupon/detail/${row[9]}`)
    }
    const filterList = (queryPayload) => {
        let payload = {
            ...queryPayload,
        }
        dispatch(getCoupons(payload))
    }

    const getTableColumns = () => {
        let editObj = {
            label: "Actions",
            name: '',
            options: { 
                filter: true,
                sort: false, 
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div className='d-flex align-items-center justify-content-center'>
                        <div
                            onClick={() => getApplicationDetails(tableMeta?.rowData)}
                        >
                            <MdOutlineRemoveRedEye size={18}/>
                        </div>
                    </div>
                )
            }
        }
        let newtable = [...CouponsColumn,editObj]
         return newtable
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Marketplace" breadcrumbItem="Coupons" />
                    <CustomBootstrapTable 
                        rows = {couponsList}
                        columns = {getTableColumns()}
                        isLoading={false}
                        showCreateBtn = {true}
                        keyField={'_id'}
                        createBtnLabel="Add New Coupon"
                        onCreateRedirect = {`/staff/coupons/coupon/detail`}
                        getApplicationDetails={(row) => null}
                        showStatusFilter={false}
                        showDateFilter={false}
                        history = {props.history}
                        filterList = {(...params) => filterList(...params)}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export { Coupons }